import strings from 'owa-strings/owa-mail-strings';
import { computed, IComputedValue } from 'mobx';

export interface ColorPickerItem {
    name: string;
    code: string;
    borderColor?: string;
}

let textColors = computed(() => [
    { name: strings.lightBlueColor, code: '#51a7f9' },
    { name: strings.lightGreenColor, code: '#6fc040' },
    { name: strings.lightYellowColor, code: '#f5d427' },
    { name: strings.lightOrangeColor, code: '#f3901d' },
    { name: strings.lightRedColor, code: '#ed5c57' },
    { name: strings.lightPurpleColor, code: '#b36ae2' },
    { name: strings.blueColor, code: '#0c64c0' },
    { name: strings.greenColor, code: '#0c882a' },
    { name: strings.yellowColor, code: '#dcbe22' },
    { name: strings.orangeColor, code: '#de6a19' },
    { name: strings.redColor, code: '#c82613' },
    { name: strings.purpleColor, code: '#763e9b' },
    { name: strings.darkBlueColor, code: '#174e86' },
    { name: strings.darkGreenColor, code: '#0f5c1a' },
    { name: strings.darkYellowColor, code: '#c3971d' },
    { name: strings.darkOrangeColor, code: '#be5b17' },
    { name: strings.darkRedColor, code: '#861106' },
    { name: strings.darkPurpleColor, code: '#5e327c' },
    { name: strings.darkerBlueColor, code: '#002451' },
    { name: strings.darkerGreenColor, code: '#06400c' },
    { name: strings.darkerYellowColor, code: '#a37519' },
    { name: strings.darkerOrangeColor, code: '#934511' },
    { name: strings.darkerRedColor, code: '#570606' },
    { name: strings.darkerPurpleColor, code: '#3b204d' },
    { name: strings.whiteColor, code: '#ffffff', borderColor: '#bebebe' },
    { name: strings.lightGrayColor, code: '#cccccc' },
    { name: strings.grayColor, code: '#999999' },
    { name: strings.darkGrayColor, code: '#666666' },
    { name: strings.darkerGrayColor, code: '#333333' },
    { name: strings.blackColor, code: '#000000' },
]) as IComputedValue<ColorPickerItem[]>;

export { textColors };

let backColors = computed(() => [
    { name: strings.cyanColor, code: '#00ffff' },
    { name: strings.greenColor, code: '#00ff00' },
    { name: strings.yellowColor, code: '#ffff00' },
    { name: strings.orangeColor, code: '#ff8000' },
    { name: strings.redColor, code: '#ff0000' },
    { name: strings.magentaColor, code: '#ff00ff' },
    { name: strings.lightCyanColor, code: '#80ffff' },
    { name: strings.lightGreenColor, code: '#80ff80' },
    { name: strings.lightYellowColor, code: '#ffff80' },
    { name: strings.lightOrangeColor, code: '#ffc080' },
    { name: strings.lightRedColor, code: '#ff8080' },
    { name: strings.lightMagentaColor, code: '#ff80ff' },
    { name: strings.whiteColor, code: '#ffffff', borderColor: '#bebebe' },
    { name: strings.lightGrayColor, code: '#cccccc' },
    { name: strings.grayColor, code: '#999999' },
    { name: strings.darkGrayColor, code: '#666666' },
    { name: strings.darkerGrayColor, code: '#333333' },
    { name: strings.blackColor, code: '#000000' },
]) as IComputedValue<ColorPickerItem[]>;

export { backColors };
